import { useAppSelector } from 'src/hooks/useStore';
import { arrayToMap } from 'src/utils/array';
import { GetDefaultCurrency } from 'src/utils/PaymentsUtils';

export const useDefaultCurrency = () => {
  const { portalDefaultCurrency } = useAppSelector((state) => ({
    portalDefaultCurrency: state.payments.accountInfo?.default_currency,
    companies: arrayToMap(state.clients.companies, 'id'),
  }));

  return portalDefaultCurrency || GetDefaultCurrency();
};
